// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"129":"2c99373c2aee67a7","133":"989da67312e58031"}[chunkId] + ".css";
};